// // src/redux/studentSlots/slice.js
// import { createSlice } from "@reduxjs/toolkit";
// import {
//   fetchAvailableSlots,
//   // bookSlot,
//   fetchStudentBookings,
//   cancelStudentBooking,
// } from "./operation.js";

// const initialState = {
//   slots: [],
//   loading: false,
//   error: null,
// };

// const studentBokkings = createSlice({
//   name: "studentBookings",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAvailableSlots.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAvailableSlots.fulfilled, (state, action) => {
//         state.loading = false;
//         state.slots = action.payload;
//       })
//       .addCase(fetchAvailableSlots.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     // .addCase(bookSlot.fulfilled, (state, action) => {
//     //   // можно обновить локальный список или перезапросить
//     // });
//     builder
//       .addCase(fetchStudentBookings.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchStudentBookings.fulfilled, (state, action) => {
//         state.loading = false;
//         state.bookings = action.payload;
//       })
//       .addCase(fetchStudentBookings.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       .addCase(cancelStudentBooking.fulfilled, (state, action) => {
//         state.bookings = state.bookings.map((b) =>
//           b.booking_id === action.payload.bookingId
//             ? {
//                 ...b,
//                 status: "cancelled",
//                 cancelled_at: action.payload.cancelled_at,
//               }
//             : b
//         );
//       });
//   },
// });

// export default studentBokkings.reducer;

// src/redux/studentBookings/slice.js
// import { createSlice } from "@reduxjs/toolkit";
// import {
//   fetchStudentBookings,
//   cancelStudentBooking,
//   archiveStudentBooking,
//   unarchiveStudentBooking,
// } from "./operation.js";

// const initialState = {
//   activeBookings: [],
//   archivedBookings: [],
//   loading: false,
//   error: null,
// };

// const studentBookings = createSlice({
//   name: "studentBookings",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       // 🔄 Загрузка бронирований
//       .addCase(fetchStudentBookings.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchStudentBookings.fulfilled, (state, action) => {
//         state.loading = false;
//         state.error = null;

//         if (action.payload.mode === "active") {
//           state.activeBookings = action.payload.bookings;
//         } else {
//           state.archivedBookings = action.payload.bookings;
//         }
//       })
//       .addCase(fetchStudentBookings.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // ❌ Отмена брони → обновляем активные
//       .addCase(cancelStudentBooking.fulfilled, (state, action) => {
//         state.activeBookings = state.activeBookings.map((b) =>
//           b.booking_id === action.payload.bookingId
//             ? {
//                 ...b,
//                 status: "cancelled",
//                 cancelled_at: action.payload.cancelled_at,
//                 archived: true, // сразу уходит в архив
//               }
//             : b
//         );
//       })

//       // 📥 Архивация
//       .addCase(archiveStudentBooking.fulfilled, (state, action) => {
//         const id = action.payload;
//         const target = state.activeBookings.find((b) => b.booking_id === id);
//         if (target) {
//           target.archived = true;
//           state.archivedBookings.push(target);
//           state.activeBookings = state.activeBookings.filter(
//             (b) => b.booking_id !== id
//           );
//         }
//       })

//       // 📤 Возврат из архива
//       .addCase(unarchiveStudentBooking.fulfilled, (state, action) => {
//         const id = action.payload;
//         const target = state.archivedBookings.find((b) => b.booking_id === id);
//         if (target) {
//           target.archived = false;
//           state.activeBookings.push(target);
//           state.archivedBookings = state.archivedBookings.filter(
//             (b) => b.booking_id !== id
//           );
//         }
//       });
//   },
// });

// export default studentBookings.reducer;

import { createSlice } from "@reduxjs/toolkit";
import {
  fetchStudentBookings,
  cancelStudentBooking,
  archiveStudentBooking,
  unarchiveStudentBooking,
} from "./operation.js";

const initialState = {
  activeBookings: [],
  archived: {
    bookings: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
  },
  loading: false,
  error: null,
};

const studentBookings = createSlice({
  name: "studentBookings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🔄 Загрузка бронирований
      .addCase(fetchStudentBookings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        if (action.payload.mode === "active") {
          state.activeBookings = action.payload.bookings;
        } else if (action.payload.mode === "archived") {
          state.archived = {
            bookings: action.payload.bookings,
            total: action.payload.total,
            totalPages: action.payload.totalPages,
            currentPage: action.payload.currentPage,
          };
        }
      })
      .addCase(fetchStudentBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ❌ Отмена брони → обновляем активные
      .addCase(cancelStudentBooking.fulfilled, (state, action) => {
        state.activeBookings = state.activeBookings.map((b) =>
          b.booking_id === action.payload.bookingId
            ? {
                ...b,
                status: "cancelled",
                cancelled_at: action.payload.cancelled_at,
                archived: true,
              }
            : b
        );
      })

      // 📥 Архивация
      .addCase(archiveStudentBooking.fulfilled, (state, action) => {
        const id = action.payload;
        const target = state.activeBookings.find((b) => b.booking_id === id);
        if (target) {
          target.archived = true;
          state.archived.bookings.push(target);
          state.activeBookings = state.activeBookings.filter(
            (b) => b.booking_id !== id
          );
        }
      })

      // 📤 Возврат из архива
      .addCase(unarchiveStudentBooking.fulfilled, (state, action) => {
        const id = action.payload;
        const target = state.archived.bookings.find((b) => b.booking_id === id);
        if (target) {
          target.archived = false;
          state.activeBookings.push(target);
          state.archived.bookings = state.archived.bookings.filter(
            (b) => b.booking_id !== id
          );
        }
      });
  },
});

export default studentBookings.reducer;
